import { componentFileUploadTypes } from 'src/types';
import { regexpLocals } from 'src/locals';
import { isDefined } from 'class-validator';
import { urlsConfig } from 'src/configs';

export const convertDataURLsToFormData = (attachments: componentFileUploadTypes.AttachmentList): FormData => {
  const formData = new FormData();

  if (attachments && attachments.length > 0) {
    attachments?.forEach(async (eachAttachment, index: number) => {
      if (!eachAttachment) {
        formData.append('attachments', '');
        return;
      }

      if (eachAttachment.file) {
        formData.append('attachments', eachAttachment.file);

        return;
      }

      if (eachAttachment.url) {
        const type = eachAttachment.url.split(regexpLocals.semicolonRegexp)[0].replace('data:', '');
        const binaryAttachment = atob(eachAttachment.url.split(',')[1]);
        const binaryAttachmentArray = [];

        for (let i = 0; i < binaryAttachment.length; i += 1) {
          binaryAttachmentArray.push(binaryAttachment.charCodeAt(i));
        }

        const file = new File([new Uint8Array(binaryAttachmentArray)], `attachment-${index}`, { type });

        formData.append(`attachments`, file);
      }
    });
  }

  return formData;
};

export const convertResourceDataURLsToFormData = (
  attachments: componentFileUploadTypes.AttachmentListResource,
): FormData => {
  const formData = new FormData();

  if (!attachments) {
    formData.append('attachments', '');
  }

  if (attachments.file) {
    formData.append('attachments', attachments.file);
  }

  return formData;
};

export const convertArrayData = (value: any) => {
  const arrayListeleme: any = [];
  value.forEach((element: any) => {
    arrayListeleme.push(element);
  });

  return arrayListeleme;
};
